import * as angular from 'angular';

import { ReportTypes } from '@mode/shared/contract-common';

/**
 * Parameters info and tooltip presentation component.
 *
 * This component provides a few options to configure some information
 * and a tooltip listing parameters.
 */
class ParametersInfoFieldController implements angular.IController {
  // bindings
  parameter: ReportTypes.ReportRunFormField;

  // local
  tooltipTemplate: string;

  constructor() {}

  $onChanges(changes: angular.IOnChangesObject) {
    if (
      changes.parameter &&
      changes.parameter.currentValue != null &&
      Array.isArray(changes.parameter.currentValue.value)
    ) {
      this.tooltipTemplate = this.buildParametersTooltipTemplate(this.parameter);
    }
  }

  /**
   * Display only 1 param if its a multiselect
   */
  formattedValue(parameter: ReportTypes.ReportRunFormField) {
    if (Array.isArray(parameter.value)) {
      return parameter.value[0];
    }
    return parameter.value;
  }

  /**
   * Only show the tooltip if its a multiselect with 2+ selections
   */
  displayShowMore(parameter: ReportTypes.ReportRunFormField) {
    return Array.isArray(parameter.value) && parameter.value.length > 1;
  }

  /**
   * Build the parameters tooltip template
   */
  buildParametersTooltipTemplate(params: ReportTypes.ReportRunFormField) {
    let paramsItems = '';
    params.value.slice(1).forEach((value) => {
      paramsItems += `
      <li>
        <div class="tooltip-item">
          <p class="tooltip-item-name">${value}</p>
        </div>
      </li>
      `;
    });

    const template = `
    <div>
      <ul class="tooltip-items">
        ${paramsItems}
      </ul>
    </div>
    `;

    return template;
  }
}

export const ParametersInfoFieldComponent: angular.IComponentOptions = {
  bindings: {
    parameter: '<',
  },
  controller: ParametersInfoFieldController,
  controllerAs: 'ctrl',
  template: `
      <dt>{{ctrl.parameter.label}}</dt>
      <dd>{{ctrl.formattedValue(ctrl.parameter)}}
        <span ng-if="ctrl.displayShowMore(ctrl.parameter)"> + </span>
        <span
          ng-if="ctrl.displayShowMore(ctrl.parameter)"
          uib-tooltip-html="ctrl.tooltipTemplate"
          tooltip-append-to-body="true"
          tooltip-popup-delay="5"
          tooltip-placement="bottom"
          tooltip-class="info-tooltip parameters-tooltip"
          class="parameter-multi-select-tooltip"
        >
          {{ctrl.parameter.value.length - 1}} more
        </span>
      </dd>
  `,
};
